<script>
    import PostCard from '../components/PostCard.svelte'
    import FaCheck from 'svelte-icons/fa/FaCheck.svelte'
    import FaArrowRight from 'svelte-icons/fa/FaArrowRight.svelte'
    import FaAngleUp from 'svelte-icons/fa/FaAngleUp.svelte'
    import {navigate} from 'svelte-routing'
    import FAQ from '../components/FAQ.svelte'
    import {emitPageViewEvent} from '../actions/pageAnalytics'
    import HomeMarketingBullet from '../components/HomeMarketingBullet.svelte'
    import Quote from '../components/Quote.svelte'

    export let location
    let playVideo = false
    emitPageViewEvent(location, 'Home')
    window.scrollTo(0, 0)
    const DEFAULT_CARD = {
        title: 'Happy Birthday!',
        message: 'Can\'t wait to see you after this is all over.',
    }
    const content = Object.assign({}, DEFAULT_CARD)

    function goToCreate() {
        let queryParams = ''
        if (content.title !== DEFAULT_CARD.title || content.message !== DEFAULT_CARD.message) {
            queryParams = `?title=${encodeURIComponent(content.title)}&message=${encodeURIComponent(content.message)}`
        }
        navigate('/new' + queryParams)
    }
</script>
<style>
    h1 {
        font-weight: bold;
    }
    .jumbo {
        border-radius: 1rem;
    }

    .postCardArea {
        position: relative;
        min-width: 360px;
    }

    .cta {
        min-width: 12rem;
    }

    .sellers h3 {
        margin-top: 0.5rem;
        display: flex;
    }

    .sellers .icon {
        flex: none;
    }

    .point {
        padding: 0.5rem;
        border-radius: 0.5rem;
        margin-right: 1rem;
        background-color: #C3DAFE;
        color: var(--ink);
        font-size: 0.5em;
    }

    .payMark {
        height: 2rem;
    }

    button .icon {
        height: 0.8em;
        align-self: center;
    }

    .samplePicture {
        border: var(--gray) 1px solid;
        border-radius: 1rem;
        width: 360px;
        height: 450px;
        background: var(--area);
    }
    .payments {
        background: var(--white);
        border-radius: 0.5rem;
    }

    @media (max-width: 50em) {
        .row {
            flex-direction: column;
            align-items: center;
            max-width: 25rem;
            align-self: center;
        }
    }

    @media (max-width: 25em) {
        .samplePicture {
            width: 280px;
            height: 350px;
        }
    }

    .thumbnail {
        cursor: pointer;
    }

    .thumbnail:hover {
        opacity: 0.5;
    }
</style>
<div class="flex flex-column">
    <div class="flex flex-column items-center p2 my2 jumbo">

        <div class='flex flex-column'>
            <h1 class='m2'>
                📮 Type a message, and we'll mail it.
            </h1>
            <div class="postCardArea mt3 self-center ">

                <PostCard content={content} bind:fromName={content.fromName} demoMessage={DEFAULT_CARD.message}/>
                <h6 class='center mt1'><span class="icon"><FaAngleUp/></span><br>Try it out! Click to edit.</h6>
            </div>
        </div>


        <div class="flex flex-column sellers items-start my3">
            <h3><span class="icon point"><FaCheck/></span><span>Only takes <b>30 seconds.</b></span></h3>
            <h3><span class="icon point"><FaCheck/></span><span>No sign-up. No logins. No ads.</span></h3>
            <h3><span class="icon point"><FaCheck/></span><span>Just <b>$2.00 USD</b> per postcard!</span></h3>
            <h3><span class="icon point"><FaCheck/></span><span>Delivered in 3-5 business days.</span></h3>

        </div>
        <button class='cta self-center px4 primary' on:click={goToCreate}>
            Get Started!<span class="icon ml1"><FaArrowRight/></span>
        </button>

    </div>
    <!--        <hr/>-->

    <div class="row picture flex">
        <div class="flex flex-column fixedColumn my3 mt4 flex-none relative">
            {#if playVideo}
                <iframe class='samplePicture' src="https://www.youtube.com/embed/Bpvy34j1qEY?&autoplay=1&rel=0"
                        frameBorder="0"
                        width='360'
                        height='450'
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            {:else}
                <img class='thumbnail samplePicture' src="res/video thumbnail.png" alt="Demo thumbnail"
                     on:click={()=>playVideo = true}>
            {/if}
            <h5 class='mt1 nearInkText'>Click to view demo video.</h5>
        </div>
        <div class="right-col flex flex-column p3 self-center">
            <h1 class='bold py2'>High quality prints!</h1>
            <h2 class='py2 center'>Every card is printed on <b>thick, glossy, laminated card stock.</b></h2>
            <a class='center mt3' href="https://www.producthunt.com/posts/post-a-note?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-post-a-note" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=229659&theme=light" alt="Post A Note - Type a message, and we'll deliver it on a laminated postcard | Product Hunt Embed" style="width: 250px; height: 54px;" width="250px" height="54px" /></a>
            <!--            <Quote cl='px2'>It's thicker than a plastic playing card!</Quote>-->
        </div>
    </div>
    <div class="p2 my3 flex flex-column">
        <h1 class='m center'>Surprise your friends and family!</h1>
        <div class='flex flex-column fixedColumn self-center'>
            <div class="m2">
                <HomeMarketingBullet img="res/019-couple.svg" alt='parents'>Send your parents a nice message.
                </HomeMarketingBullet>
                <HomeMarketingBullet img='res/014-present.svg' alt='birthday'>Make someone's birthday feel special.
                </HomeMarketingBullet>
                <HomeMarketingBullet img='res/037-envelope.svg' alt='grandparents'>Remind your grandparents that you
                    miss them.
                </HomeMarketingBullet>
                <HomeMarketingBullet img='res/011-love.svg' alt='love'>Surprise your long-distance partner.
                </HomeMarketingBullet>
                <HomeMarketingBullet img='res/033-hotel.svg' alt='coworkers'>Thank a co-worker.</HomeMarketingBullet>
                <HomeMarketingBullet img='res/003-flower.svg' alt='flower'>Hit up an old friend.</HomeMarketingBullet>

            </div>
            <h2 class='my3 center '><i>What are you waiting for?</i> 😁</h2>
            <button class='cta self-center px4 primary' on:click={goToCreate}>
                Make a card!<span class="icon ml1"><FaArrowRight/></span>
            </button>
        </div>
    </div>


    <div class="payments flex flex-column py3 mt2">
        <!--        <h2 class='center'>FAQ</h2>-->
        <h4 class='center mb2'>We accept all forms of payment.</h4>
        <div class="flex justify-center">
            <img class='payMark mr2' src="res/ApplePayMark.svg" alt="Powered by stripe.">
            <img class='payMark mr2' src="res/GooglePayMark.svg" alt="Powered by stripe.">
            <img class='payMark' src="res/powered_by_stripe.svg" alt="Powered by stripe.">
        </div>
    </div>
</div>
